import React from 'react';
import './footer.css';

const Footer = () => (
  <footer className="footer">
    <div className="footer-top">
      <h3>Choose what kind of model suits your business.</h3>
      <button className="footer-button">Explore Options</button>
    </div>
    <div className="footer-content">
      <div className="contact-info">
        {/* <p>✆ (188) 567-4765</p><br /> */}
        <p>✉ contact@tutorsgift.com</p>
      </div>
      <div className="links">
        <b>Quick Links</b>
        <ul>
          <li><a href="/home">Home</a></li>
          <li><a href="/features">Features</a></li>

        </ul>
      </div>
      <div className="links">
        <b>Company</b>
        <ul>
          <li><a href="/blog">Blog</a></li>
          {/* <li><a href="/about-us">About Us</a></li> */}
          <li><a href="/ContactUs">Contact Us</a></li>

        </ul>
      </div>
      <div className="social-links">
        <b>Follow Us On</b>
        <ul>
          <li><a href="https://www.facebook.com/share/19TnXDwxZA/?mibextid=wwXIfr">ⓕ Facebook</a></li>
          <li><a href="https://x.com/tutorsgift">𝕏 Twitter</a></li>
          <li><a href="https://www.instagram.com/tutorsgift?igsh=MXZqaXU4eGZ5eHh2">🅾 Instagram</a></li>
          <li><a href="https://www.youtube.com/channel/UCvju0MwYm-BhC4IlLaPXwuQ">▶ Youtube</a></li>
        </ul>
      </div>
    </div>
    <div className="rights">
      <p>&copy; Tutor's Gift, All Rights Reserved 2025</p>
    </div>
  </footer>
);

export default Footer;
